module.exports = __webpack_public_path__ + "img/interslavic.8be157d6.svg";